'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _dec2, _dec3, _dec4, _dec5, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _chemist = require('chemist');

var _reactI18next = require('react-i18next');

var _reactCookie = require('react-cookie');

var _reactCookie2 = _interopRequireDefault(_reactCookie);

var _prefetch = require('chemist/dist/helpers/prefetch');

var _prefetch2 = _interopRequireDefault(_prefetch);

var _redirectable = require('../../helpers/redirectable');

var _redirectable2 = _interopRequireDefault(_redirectable);

var _loading = require('../../actions/loading');

var _localisedPaths = require('../../helpers/localisedPaths');

var _orders = require('../../actions/orders');

var _CheckoutBanner = require('../../components/CheckoutBanner');

var _CheckoutBanner2 = _interopRequireDefault(_CheckoutBanner);

var _MessageWithAction = require('../../components/MessageWithAction');

var _MessageWithAction2 = _interopRequireDefault(_MessageWithAction);

var _OrderTable = require('../../components/OrderTable');

var _OrderTable2 = _interopRequireDefault(_OrderTable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var OrderIndexPage = (_dec = (0, _prefetch2.default)(function (_ref) {
  var store = _ref.store;

  return store.dispatch((0, _orders.orders)());
}), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    orders: state.orders
  };
}), _dec3 = (0, _chemist.configurable)(), _dec4 = (0, _reactI18next.translate)(), _dec5 = (0, _redirectable2.default)(), _dec(_class = _dec2(_class = _dec3(_class = _dec4(_class = _dec5(_class = function (_React$Component) {
  (0, _inherits3.default)(OrderIndexPage, _React$Component);

  function OrderIndexPage() {
    (0, _classCallCheck3.default)(this, OrderIndexPage);
    return (0, _possibleConstructorReturn3.default)(this, (OrderIndexPage.__proto__ || (0, _getPrototypeOf2.default)(OrderIndexPage)).apply(this, arguments));
  }

  (0, _createClass3.default)(OrderIndexPage, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ redirecting: !_reactCookie2.default.load('user') });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!_reactCookie2.default.load('sessionToken')) {
        this.props.localisedRedirect('/cart');
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.props.dispatch((0, _loading.clearLoading)());
    }
  }, {
    key: 'renderTable',
    value: function renderTable() {
      var t = this.props.t;

      var lng = this.props.params.lng;

      if (this.props.orders.length !== 0) {
        return _react2.default.createElement(_OrderTable2.default, { orders: this.props.orders, params: this.props.params });
      }

      return _react2.default.createElement(_MessageWithAction2.default, {
        url: (0, _localisedPaths.localisedPath)(this.props.config.store, 'productsPath', lng),
        message: t('spree.you_have_no_orders_yet'),
        actionLabel: t('spree.back_to_store')
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var t = this.props.t;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_CheckoutBanner2.default, { title: t('spree.my_order_history') }),
        _react2.default.createElement(
          'div',
          { className: 'container container-page' },
          _react2.default.createElement(_reactHelmet2.default, { title: t('spree.my_order_history') }),
          this.renderTable()
        )
      );
    }
  }]);
  return OrderIndexPage;
}(_react2.default.Component)) || _class) || _class) || _class) || _class) || _class);
exports.default = OrderIndexPage;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./shared/containers/OrderIndexPage/index.js
// module id = 2512
// module chunks = 0